(() => {
  const initialize = (root) => {
    if (root.dataset.soterReady === "true") return;
    const carousel = root.querySelector("[data-soter-carousel]");
    const stage = root.querySelector("[data-soter-stage]");
    const details = root.querySelector("[data-soter-details]");
    if (!carousel || !stage || !details) return;

    const initialSlides = [...stage.querySelectorAll("[data-soter-slide]")];
    if (!initialSlides.length) return;
    while (stage.querySelectorAll("[data-soter-slide]").length < 3) {
      const clone =
        initialSlides[
          stage.querySelectorAll("[data-soter-slide]").length %
            initialSlides.length
        ].cloneNode(true);
      clone.dataset.soterClone = "true";
      stage.insertBefore(clone, stage.querySelector("[data-soter-previous]"));
    }

    const slides = [...stage.querySelectorAll("[data-soter-slide]")];
    const progress = root.querySelector("[data-soter-progress]");
    const title = details.querySelector("[data-soter-title]");
    const variant = details.querySelector("[data-soter-variant]");
    const price = details.querySelector("[data-soter-price]");
    const comparePrice = details.querySelector("[data-soter-compare-price]");
    const link = details.querySelector("[data-soter-link]");
    let active = 0;
    let pointerStart = null;
    let pointerCurrent = null;
    let pointerId = null;
    let didDrag = false;

    const dragLimit = () => {
      if (window.matchMedia("(max-width: 520px)").matches) return 28;
      if (window.matchMedia("(max-width: 860px)").matches) return 42;
      return 70;
    };

    const dragThreshold = () =>
      window.matchMedia("(max-width: 520px)").matches ? 34 : 42;

    const positionFor = (index) => {
      if (index === active) return "center";
      if (index === (active - 1 + slides.length) % slides.length) return "left";
      if (index === (active + 1) % slides.length) return "right";
      return "hidden";
    };

    const render = (nextIndex, direction = 1) => {
      active = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const position = positionFor(index);
        slide.dataset.position = position;
        slide.setAttribute("aria-hidden", String(position === "hidden"));
        const productControl = slide.querySelector(".soter-coverflow__product");
        productControl.style.setProperty("--soter-tilt-x", "0deg");
        productControl.style.setProperty("--soter-tilt-y", "0deg");
        productControl.tabIndex = position === "hidden" ? -1 : 0;
        productControl.setAttribute(
          "aria-label",
          position === "center"
            ? `${slide.dataset.title}, מעבר למוצר`
            : `בחירת ${slide.dataset.title}`,
        );
        const image = slide.querySelector("img");
        if (!image.dataset.alt)
          image.dataset.alt = image.alt || slide.dataset.title;
        image.alt = position === "center" ? image.dataset.alt : "";
      });

      const selected = slides[active];
      variant.textContent =
        selected.dataset.variant === "Default Title"
          ? "משקפיים לסינון אור כחול"
          : selected.dataset.variant;
      title.textContent = selected.dataset.title;
      price.textContent = selected.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = selected.dataset.comparePrice || "";
        comparePrice.hidden = !selected.dataset.comparePrice;
      }
      link.href = selected.dataset.url;
      details.animate?.(
        [
          { opacity: 0, transform: `translateY(${direction * 12}px)` },
          { opacity: 1, transform: "translateY(0)" },
        ],
        { duration: 420, easing: "cubic-bezier(.22,1,.36,1)" },
      );
      [...(progress?.children || [])].forEach((control, index) => {
        control.toggleAttribute("aria-current", index === active);
      });
    };

    const moveBy = (offset) => render(active + offset, offset < 0 ? -1 : 1);

    slides.forEach((slide, index) => {
      const productControl = slide.querySelector(".soter-coverflow__product");
      productControl.addEventListener("click", (event) => {
        if (didDrag) {
          event.preventDefault();
          return;
        }
        const url = slide.dataset.url || productControl.href;
        if (url) {
          event.preventDefault();
          window.location.href = url;
        }
      });
      productControl.addEventListener("pointermove", (event) => {
        if (slide.dataset.position !== "center") return;
        if (pointerId !== null) return;
        const bounds = productControl.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;
        productControl.style.setProperty("--soter-tilt-x", `${(-y * 8).toFixed(2)}deg`);
        productControl.style.setProperty("--soter-tilt-y", `${(x * 12).toFixed(2)}deg`);
      });
      productControl.addEventListener("pointerleave", () => {
        productControl.style.setProperty("--soter-tilt-x", "0deg");
        productControl.style.setProperty("--soter-tilt-y", "0deg");
      });
      productControl.addEventListener("dragstart", (event) => {
        event.preventDefault();
      });
    });
    slides.forEach((_, index) => {
      const control = document.createElement("button");
      control.type = "button";
      control.setAttribute("aria-label", `הצגת מוצר ${index + 1}`);
      control.addEventListener("click", () =>
        render(index, index < active ? -1 : 1),
      );
      progress?.append(control);
    });

    const previous = root.querySelector("[data-soter-previous]");
    const next = root.querySelector("[data-soter-next]");
    [previous, next].forEach((control) => {
      control?.addEventListener(
        "pointerdown",
        (event) => {
          event.stopPropagation();
          didDrag = false;
        },
        { capture: true },
      );
    });
    previous?.addEventListener("click", (event) => {
      event.stopPropagation();
      didDrag = false;
      moveBy(-1);
    });
    next?.addEventListener("click", (event) => {
      event.stopPropagation();
      didDrag = false;
      moveBy(1);
    });
    carousel.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") moveBy(-1);
      if (event.key === "ArrowRight") moveBy(1);
    });

    stage.addEventListener("pointerdown", (event) => {
      if (event.target.closest("[data-soter-previous], [data-soter-next]"))
        return;
      pointerStart = event.clientX;
      pointerCurrent = event.clientX;
      pointerId = event.pointerId;
      didDrag = false;
      stage.dataset.dragging = "true";
      stage.setPointerCapture?.(event.pointerId);
    });

    stage.addEventListener("pointermove", (event) => {
      if (pointerId !== event.pointerId || pointerStart === null) return;
      pointerCurrent = event.clientX;
      const distance = pointerCurrent - pointerStart;
      if (Math.abs(distance) > 8 && !didDrag) {
        didDrag = true;
      }
      if (didDrag) event.preventDefault();
      const maxDrag = dragLimit();
      stage.style.setProperty(
        "--soter-drag-x",
        `${Math.max(-maxDrag, Math.min(maxDrag, distance * 0.22)).toFixed(2)}px`,
      );
    });

    const endDrag = (event) => {
      if (pointerId !== event.pointerId || pointerStart === null) return;
      const distance = (pointerCurrent ?? event.clientX) - pointerStart;
      if (Math.abs(distance) > dragThreshold()) moveBy(distance < 0 ? 1 : -1);
      pointerStart = null;
      pointerCurrent = null;
      pointerId = null;
      stage.dataset.dragging = "false";
      stage.style.setProperty("--soter-drag-x", "0px");
      window.setTimeout(() => {
        didDrag = false;
      }, 0);
    };

    stage.addEventListener("pointerup", endDrag);
    stage.addEventListener("pointercancel", (event) => {
      if (pointerId !== event.pointerId) return;
      pointerStart = null;
      pointerCurrent = null;
      pointerId = null;
      stage.dataset.dragging = "false";
      stage.style.setProperty("--soter-drag-x", "0px");
      window.setTimeout(() => {
        didDrag = false;
      }, 0);
    });

    root.dataset.soterReady = "true";
    render(0);
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.("[data-soter-storefront]")) initialize(scope);
    scope.querySelectorAll?.("[data-soter-storefront]").forEach(initialize);
  };
  const boot = () => initializeAll(document);
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", boot)
    : boot();
  window.setTimeout(boot, 0);
  document.addEventListener("shopify:section:load", (event) =>
    initializeAll(event.target),
  );
  document.addEventListener("shopify:section:select", (event) =>
    initializeAll(event.target),
  );
  new MutationObserver((entries) =>
    entries.forEach((entry) =>
      entry.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initializeAll(node);
      }),
    ),
  ).observe(document.documentElement, { childList: true, subtree: true });
})();
